<template>
  <v-card elevation="0" class="pa-4" color="" tile>
    <v-row class="">
      <v-col class="" cols="6" md="6">
        <v-row class="justify-center">
          <v-col cols="12" md="8">
            <v-card elevation="0">
              <div class="d-flex justify-center">
                <v-img
                  class="mb-4 text-center"
                  width="560"
                  max-width="300"
                  src="https://tmt-s3-v2.s3.amazonaws.com/public/marketplace.png"
                ></v-img>
              </div>
              <v-card-text class="text-center">
                <div class="d-flex flex-column mb-4 j">
                  <span class="font-weight-bold headline">{{
                    $t("account.whitelabel.marketPlace.title")
                  }}</span>
                </div>
                <span class="body-1"
                  >{{ $t('home.platforms.marketplace.message') }}</span
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-card elevation="0" class="">
          <div class="d-flex mb-6 align-center">
            <v-text-field
              class="mr-2"
              style="flex: 0 1 400px"
              append-icon="mdi-magnify"
              outlined
              :label="this.$t('account.whitelabel.data.usersManagement.search')"
              single-line
              dense
              hide-details
            ></v-text-field>
                <v-btn color="success" elevation="0" @click="publiRequestDialog = true">
                  Solicitar novo
                </v-btn>
                
             
                <v-btn color="success" elevation="0" @click="requestsProfile = true">
                  Novos cadastros
                </v-btn>
            
          </div>
          <v-card elevation="0" outlined class="">
            <v-data-table
              hide-default-header
              :hide-default-footer="documents.length < 10"
              :headers="headers"
              :items="documents"
              hide-overflow
              :height="350"
            >
              <template v-slot:[`item.pub_log`]="{ item }">
                <v-img
                  class="my-1"
                  width="60"
                  height="60"
                  :src="item.logo"
                ></v-img>
              </template>
              <template v-slot:[`item.stats`]="{}">
                <v-btn class="" icon small><v-icon>mdi-finance</v-icon></v-btn>
              </template>
              <template v-slot:[`item.edit`]="{}">
                <v-btn class="" icon small
                  ><v-icon>mdi-pencil-outline</v-icon></v-btn
                >
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip
                  label
                  small
                  v-if="item.status == 'Ativo'"
                  color="success"
                  >{{ $t("common.active") }}</v-chip
                >
                <v-chip label small v-else>{{ $t("common.inactive") }}</v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="requestsProfile" width="1366">
      <v-card>
        <v-card-title>
          Solicitações de parceria
          <v-spacer></v-spacer>
          <v-btn icon @click="requestsProfile = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
            <PartnersRequests></PartnersRequests>
          </v-card-text>
          </v-card>
        </v-dialog>
    <v-dialog v-model="publiRequestDialog" width="500">
      <v-card>
     
        <v-card-title>
          <span class="text-h5">Solicitar novo veículo</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <form>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    required
                    @input="v$.publiForm.name.$touch()"
                    @blur="v$.publiForm.name.$touch()"
                    :error-messages="nameErrors"
                    v-model="publiForm.name"
                    label="Nome*"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    required
                    @input="v$.publiForm.email.$touch()"
                    @blur="v$.publiForm.email.$touch()"
                    :error-messages="emailErrors"
                    v-model="publiForm.email"
                    label="Email*"
                  ></v-text-field
                ></v-col>
                <v-col cols="12">
                  <v-text-field
                    @input="v$.publiForm.phone.$touch()"
                    @blur="v$.publiForm.phone.$touch()"
                    :error-messages="phoneErrors"
                    v-model="publiForm.phone"
                    label="Telefone*"
                    v-mask="currentCountry?.phoneMasks"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    @input="v$.publiForm.publiName.$touch()"
                    @blur="v$.publiForm.publiName.$touch()"
                    :error-messages="publiNameErrors"
                    v-model="publiForm.publiName"
                    label="Nome do veículo*"
                    type=""
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="publiRequestDialog = false"
          >
            {{  $t('common.cancel') }}
          </v-btn>
          <v-btn
            elevation="0"
            color="success"
            class="ml-1"
            @click="requestNewPublisher()"
          >
            {{  $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, email } from "@vuelidate/validators";
import moment from "moment";
import { mapActions } from "vuex";
import config from "@/store/config";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  deleteDoc,
  setDoc,
  doc,
  getDocs,
  writeBatch,
} from "firebase/firestore";
import PartnersRequests from "./PartnersRequests.vue";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    name: "MarketPlace",
    validations() {
        return {
            publiForm: {
                name: { required, minLength: minLength(3), maxLength: maxLength(100) },
                email: { required, email },
                phone: { required },
                publiName: { required },
            },
        };
    },
    data() {
        return {
            location: "",
            requestsProfile: false,
            assets: {
                countries: [
                    {
                        name: "Brasil",
                        currency: "BRL",
                        code: "BRA",
                        flag: "bra.svg",
                        lang: "es",
                        phoneMasks:"+55 (##) ####-#####",
                        phonePlaceholder: "+55 (00) 0000-0000",
                        phoneMinLength: 18,
                        index: 0,
                        personalDocument: "CPF",
                        personalDocumentMask: "###.###.###-##",
                        companyDocument: "CNPJ",
                        companyDocumentMask: "##.###.###/####-##",
                        zipCodeMask: "#####-###",
                    },
                    {
                        name: "Chile",
                        currency: "CHI",
                        code: "CHI",
                        flag: "chi.svg",
                        lang: "es",
                        phoneMasks: "+56 ## #-###-###",
                        phonePlaceholder: "+56 00 0-000-000",
                        phoneMinLength: 15,
                        index: 1,
                        personalDocument: "RUN",
                        personalDocumentMask: "##.###.###-#",
                        companyDocument: "RUT",
                        companyDocumentMask: "##.###.###-#",
                        zipCodeMask: "### ####",
                    },
                    {
                        name: "Colombia",
                        currency: "COL",
                        code: "COL",
                        flag: "col.svg",
                        lang: "es",
                        phoneMasks: "+57 ##-########",
                        phonePlaceholder: "+57 00-0000000",
                        phoneMinLength: 15,
                        index: 2,
                        personalDocument: "RUT",
                        personalDocumentMask: "##.###.###-#",
                        companyDocument: "NIT",
                        companyDocumentMask: "##.###.###-#",
                        zipCodeMask: "######",
                    },
                    {
                        name: "Mexico",
                        currency: "MEX",
                        code: "MEX",
                        flag: "mex.svg",
                        lang: "es",
                        phoneMasks: "+52 ### #######",
                        phonePlaceholder: "+52 000 0000000",
                        phoneMinLength: 15,
                        index: 3,
                        personalDocument: "CURP",
                        personalDocumentMask: "AAAA######AAAAAA##",
                        companyDocument: "RUT",
                        companyDocumentMask: "##.###.###-#",
                        zipCodeMask: "#####",
                    },
                    {
                        name: "Peru",
                        currency: "SOL",
                        code: "PER",
                        flag: "per.svg",
                        lang: "es",
                        phoneMasks: "+51 ### ### ###",
                        phonePlaceholder: "+51 000 000 000",
                        phoneMinLength: 14,
                        index: 4,
                        personalDocument: "DNI",
                        personalDocumentMask: "########-#",
                        companyDocument: "RUC",
                        companyDocumentMask: "###########",
                        zipCodeMask: "#####",
                    },
                ],
            },
            processing: false,
            publiForm: {
                name: "",
                email: "",
                phone: "",
                publiName: "",
                createdOn: "",
                location: "",
            },
            publiRequestDialog: false,
            documents: [
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Ativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Inativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Inativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Ativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Ativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Ativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Ativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Ativo",
                },
                {
                    logo: "https://firebasestorage.googleapis.com/v0/b/tmt-loja-modelo.appspot.com/o/store/logo/download-removebg-preview.png?alt=media&token=bc064ca8-1d83-4fbd-b962-e1fdf8c634a5",
                    products: "12 produtos",
                    status: "Ativo",
                },
            ],
        };
    },
    computed: {
        headers() {
            return [
                {
                    text: "logo",
                    align: "start",
                    sortable: true,
                    value: "pub_log",
                },
                {
                    text: "products",
                    align: "start",
                    sortable: true,
                    value: "products",
                },
                {
                    text: "",
                    align: "start",
                    sortable: true,
                    value: "stats",
                },
                {
                    text: "",
                    align: "start",
                    sortable: true,
                    value: "edit",
                },
                {
                    text: "",
                    align: "start",
                    sortable: true,
                    value: "status",
                },
            ];
        },
        currentCountry() {
            return this.assets.countries.find((country) => country.code == this.location);
        },
        nameErrors() {
            const errors = [];
            if (!this.v$.publiForm.name.$dirty)
                return errors;
            this.v$.publiForm.name.minLength.$invalid &&
                errors.push(this.$t("accountSettings.personalData.err.minLengthName", {
                    count: 3,
                }));
            this.v$.publiForm.name.maxLength.$invalid &&
                errors.push(this.$t("accountSettings.personalData.err.maxLengthName", {
                    count: 100,
                }));
            this.v$.publiForm.name.required.$invalid &&
                errors.push(this.$t("accountSettings.personalData.err.name"));
            return errors;
        },
        emailErrors() {
            const errors = [];
            if (!this.v$.publiForm.email.$dirty)
                return errors;
            this.v$.publiForm.email.$invalid &&
                errors.push(this.$t("accountSettings.personalData.err.email"));
            this.v$.publiForm.email.required.$invalid &&
                errors.push(this.$t("accountSettings.personalData.err.requiredEmail"));
            return errors;
        },
        phoneErrors() {
            const errors = [];
            if (!this.v$.publiForm.phone.$dirty)
                return errors;
            this.v$.publiForm.email.required.$invalid &&
                errors.push(this.$t("register.steps.user.form.phone.errors.required"));
            return errors;
        },
        publiNameErrors() {
            const errors = [];
            if (!this.v$.publiForm.publiName.$dirty)
                return errors;
            this.v$.publiForm.publiName.required.$invalid &&
                errors.push(this.$t("account.whitelabel.marketPlace.errors.publiNameRequired"));
            return errors;
        },
    },
    mounted() {
        this.publiForm.location = this.$root.auth.profile.location;
        this.location = this.$root.auth.profile.location;
    },
    methods: {
        ...mapActions("snackbar", ["showSnack"]),
        requestNewPublisher() {
            if (!this.v$.$invalid)
                this.processing = true;
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            const Form = this.publiForm;
            console.log("Form", Form);
            Form.createdOn = moment().format();
            var timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
            const id = (this.reservedId =
                timestamp +
                    "xxxxxxxxxxxxxxxx"
                        .replace(/[x]/g, () => {
                        return ((Math.random() * 16) | 0).toString(16);
                    })
                        .toLowerCase());
            setDoc(doc(db, "publisherRequest", id), Form)
                .then(() => {
                this.processing = false;
                // this.form = JSON.parse(JSON.stringify(this.snap))
            })
                .then(() => {
                this.v$.$reset();
                this.showSnack({
                    text: this.$t("sales.reserved.snackMsgSucess"),
                    color: "success",
                    timeout: 3800,
                    icon: "mdi-check",
                });
                this.publiRequestDialog = false;
            });
        },
    },
    components: { PartnersRequests }
};
</script>

<style lang="scss" scoped></style>
